import * as React from "react";
import { Typography, Button, Stack } from "@mui/material";
import {
  CustomTable,
  CustomeDialog,
  DeleteModal,
  CategoryProductDialog,
} from "../../../shared";
import AddIcon from "@mui/icons-material/Add";
import { useParams } from "react-router-dom";
import { sortItems } from "../../../utils";
import InputControl from "../../../shared/components/InputControl";
import CloseIcon from "@mui/icons-material/Close";
import { useStampCardProducts } from "../hooks";

export const StampCardProductsList = ({ isPublished = false }) => {
  const { id } = useParams();
  const {
    state,
    DeleteModals,
    handleDeleteProducts,
    handleModals,
    HandleFilterProduct,
    handleProductSelect,
    handleAssignProductToStampCard,
    onChangeFilter,
    resetFilters,
    isCreateVisible,
    isDeletable: deletable,
    handleSelectAllProducts,
  } = useStampCardProducts({
    stampCardId: id,
  });

  const ActionButtons = ({ id, row, deleteAction }) => {
    return (
      <div className="action-buttons" onClick={(e) => e.preventDefault()}>
        <img
          alt="delete"
          className={
            (["gift_card", "delivery", "stripe_fee", "surcharge"].includes(
              row?.type,
            ) ||
              isPublished) &&
            "disabled-img"
          }
          onClick={() => {
            // Prevent delete when published or special types
            if (isPublished) return;
            !["gift_card", "delivery", "stripe_fee", "surcharge"].includes(
              row?.type,
            ) && deleteAction();
          }}
          src="/icons/ic_delete.svg"
          style={{
            cursor: isPublished ? "default" : "pointer",
            opacity:
              ["gift_card", "delivery", "stripe_fee", "surcharge"].includes(
                row?.type,
              ) || isPublished
                ? 0.5
                : 1,
          }}
        />
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "name",
        sortType: (prev, curr, columnId) => {
          return sortItems(prev, curr, columnId);
        },
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        disableGlobalFilter: true,
        accessor: (row, index) => {
          return (
            <ActionButtons
              id={row.id}
              row={row}
              deleteAction={() => {
                DeleteModals(true, row.id);
              }}
            />
          );
        },
      },
    ],
    [deletable, isPublished],
  );

  // Get unique categories from all products
  const categoryOptions = React.useMemo(() => {
    const categories = state.productDetails.allCategoryProductList.map(
      (cat) => ({
        label: cat.name,
        value: cat.id,
      }),
    );
    return categories;
  }, [state.productDetails.allCategoryProductList]);

  return (
    <>
      <CustomTable
        columns={columns}
        data={state.productDetails.productList || []}
        isLoading={state?.isBusy}
        defaultSearch={true}
        tableId="stampCardProducts"
        bulkDelete={false}
        tableTitle="Eligible Products"
        headerRightContent={
          <>
            {!isPublished && (
              <Button
                type="button"
                size="medium"
                variant="text"
                onClick={() => !isPublished && handleModals(true)}
                disabled={isPublished}
              >
                Add/Modify Products
              </Button>
            )}
          </>
        }
      />

      {/* Add/Modify Products Dialog */}
      <CustomeDialog
        open={state.isOpen}
        handleClose={() => handleModals(false)}
        PaperProps={{
          sx: { width: "423px", height: "535px", p: "16px" },
        }}
        title="Eligible Products"
        content={
          <CategoryProductDialog
            Items={state.productDetails.filteredProducts}
            onSelect={handleProductSelect}
            selectedItems={state.productDetails.selectedProducts}
            onSubmit={handleAssignProductToStampCard}
            onSearch={HandleFilterProduct}
            existedProductList={state.productDetails.productList.map(
              (p) => p.id,
            )}
            disabled={state.productDetails.isSaveButtonBusy}
            type="modify"
            isLoading={state.productDetails.isModalLoading}
            isButtonLoading={state.productDetails.isSaveButtonBusy}
            onSelectAll={handleSelectAllProducts}
          />
        }
      />

      {/* Delete Product Modal */}
      <DeleteModal
        open={state.isDelete && !isPublished}
        handleClose={() => DeleteModals(false)}
        onConfirm={handleDeleteProducts}
        title="Delete Product"
        description="Are you sure you want to remove this product from the stamp card?"
      />
    </>
  );
};
